import { memo, forwardRef, useMemo } from 'react';

import { PopoverItem, PopoverOption } from './components/PopoverItem';

import styles from './styles.module.scss';

const POPOVER_WIDTH = 222;

type Props = {
  options: PopoverOption[];
  anchorEl: React.RefObject<HTMLButtonElement>;
  right?: boolean;
  bottom?: boolean;
  onClick: (selectedOption: PopoverOption) => void;
};

const ForwardedPopover = forwardRef<HTMLDivElement, Props>(
  ({ options, anchorEl, onClick, right = false, bottom = false }, ref) => {
    const popoverPositions = useMemo(() => {
      const rects = anchorEl.current?.getBoundingClientRect();
      let calculatedHorizontalPosition: number | undefined = undefined;
      let calculatedVerticalPosition: number | undefined = undefined;

      if (anchorEl.current && rects) {
        if (right) {
          calculatedHorizontalPosition =
            anchorEl.current.offsetLeft + anchorEl.current.offsetWidth - POPOVER_WIDTH;
        } else if (window.innerWidth - rects.x < POPOVER_WIDTH) {
          calculatedHorizontalPosition = anchorEl.current.offsetLeft - POPOVER_WIDTH + 10;
        } else {
          calculatedHorizontalPosition = anchorEl.current.offsetLeft + 25;
        }

        if (bottom) {
          calculatedVerticalPosition = anchorEl.current.offsetTop + anchorEl.current.offsetHeight;
        } else {
          calculatedVerticalPosition = anchorEl.current.offsetTop;
        }
      }

      return {
        width: POPOVER_WIDTH,
        top: calculatedVerticalPosition,
        left: calculatedHorizontalPosition,
      };
    }, [anchorEl, bottom, right]);

    return (
      <div className={styles.container} ref={ref} style={popoverPositions}>
        {options.map((option) => (
          <PopoverItem key={option.label} option={option} onClick={onClick} />
        ))}
      </div>
    );
  },
);

export const Popover = memo(ForwardedPopover);
